import { useEffect, useState } from "react";
import { api, parseApiError } from "@/lib/api";
import { PageHeader } from "./AdminLayout";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { toast } from "sonner";

export default function HRMPositions() {
  const [levels, setLevels] = useState([]);
  const [positions, setPositions] = useState([]);
  const [tasks, setTasks] = useState([]);
  const [selected, setSelected] = useState(null);
  const [level, setLevel] = useState({ code: "", name: "", rank_order: 1 });
  const [position, setPosition] = useState({ code: "", name: "", division_code: "FNB" });
  const [task, setTask] = useState({ task_code: "", task_name: "", expected_result: "", frequency: "daily" });

  const load = async () => {
    const [levelRes, positionRes] = await Promise.all([api.get("/hrm/job-levels"), api.get("/hrm/positions")]);
    setLevels(levelRes.data); setPositions(positionRes.data);
  };
  const loadTasks = async (id) => {
    setSelected(id);
    const res = await api.get(`/hrm/positions/${id}/task-templates`);
    setTasks(res.data);
  };
  useEffect(() => { load().catch(() => toast.error("Không tải được HRM")); }, []);

  const saveLevel = async () => {
    try { await api.post("/hrm/job-levels", level); setLevel({ code: "", name: "", rank_order: 1 }); await load(); toast.success("Đã tạo bậc"); }
    catch (e) { toast.error(parseApiError(e, "Lỗi").message); }
  };
  const savePosition = async () => {
    try { await api.post("/hrm/positions", { ...position, level_id: position.level_id || null }); setPosition({ code: "", name: "", division_code: "FNB" }); await load(); toast.success("Đã tạo vị trí"); }
    catch (e) { toast.error(parseApiError(e, "Lỗi").message); }
  };
  const saveTask = async () => {
    if (!selected) return toast.error("Chọn vị trí trước");
    try { await api.post(`/hrm/positions/${selected}/task-templates`, task); setTask({ task_code: "", task_name: "", expected_result: "", frequency: "daily" }); await loadTasks(selected); toast.success("Đã thêm checklist"); }
    catch (e) { toast.error(parseApiError(e, "Lỗi").message); }
  };

  return (
    <div data-testid="page-hrm-positions">
      <PageHeader kicker="HRM" title="Bậc, vị trí và checklist" breadcrumb={["HRM", "Vị trí"]} />
      <div className="p-6 lg:p-8 grid grid-cols-1 xl:grid-cols-3 gap-4">
        <section className="space-y-3">
          <h3 className="font-semibold">Bậc công việc</h3>
          <Input placeholder="Mã bậc" value={level.code} onChange={(e) => setLevel({ ...level, code: e.target.value })} />
          <Input placeholder="Tên bậc" value={level.name} onChange={(e) => setLevel({ ...level, name: e.target.value })} />
          <Input type="number" placeholder="Thứ hạng" value={level.rank_order} onChange={(e) => setLevel({ ...level, rank_order: Number(e.target.value) })} />
          <Button onClick={saveLevel} className="rounded-sm bg-emerald-800 hover:bg-emerald-900">Tạo bậc</Button>
          <div className="bg-white border border-stone-200 rounded-sm divide-y">
            {levels.map((item) => <div key={item.id} className="p-2 text-sm">{item.rank_order}. {item.name}</div>)}
          </div>
        </section>

        <section className="space-y-3">
          <h3 className="font-semibold">Vị trí</h3>
          <Input placeholder="Mã vị trí" value={position.code} onChange={(e) => setPosition({ ...position, code: e.target.value })} />
          <Input placeholder="Tên vị trí" value={position.name} onChange={(e) => setPosition({ ...position, name: e.target.value })} />
          <select className="w-full h-9 border border-stone-200 rounded-sm px-2" value={position.level_id || ""} onChange={(e) => setPosition({ ...position, level_id: e.target.value })}>
            <option value="">Chọn bậc</option>
            {levels.map((item) => <option key={item.id} value={item.id}>{item.name}</option>)}
          </select>
          <Textarea placeholder="Yêu cầu vị trí" value={position.description || ""} onChange={(e) => setPosition({ ...position, description: e.target.value })} />
          <Button onClick={savePosition} className="rounded-sm bg-emerald-800 hover:bg-emerald-900">Tạo vị trí</Button>
          <div className="bg-white border border-stone-200 rounded-sm divide-y">
            {positions.map((item) => (
              <button key={item.id} onClick={() => loadTasks(item.id)} className={`block w-full text-left p-2 text-sm ${selected === item.id ? "bg-emerald-50" : ""}`}>
                <div className="font-medium">{item.name}</div>
                <div className="text-xs text-stone-500">{item.code} · {item.level_name || "Chưa gán bậc"}</div>
              </button>
            ))}
          </div>
        </section>

        <section className="space-y-3">
          <h3 className="font-semibold">Checklist công việc</h3>
          <Input placeholder="Mã task" value={task.task_code} onChange={(e) => setTask({ ...task, task_code: e.target.value })} />
          <Input placeholder="Tên task" value={task.task_name} onChange={(e) => setTask({ ...task, task_name: e.target.value })} />
          <Textarea placeholder="Kết quả cần đạt" value={task.expected_result} onChange={(e) => setTask({ ...task, expected_result: e.target.value })} />
          <Button onClick={saveTask} className="rounded-sm bg-emerald-800 hover:bg-emerald-900">Thêm checklist</Button>
          <div className="bg-white border border-stone-200 rounded-sm divide-y">
            {tasks.map((item) => <div key={item.id} className="p-2 text-sm"><b>{item.task_name}</b><div className="text-xs text-stone-500">{item.expected_result}</div></div>)}
          </div>
        </section>
      </div>
    </div>
  );
}
